// extracted by mini-css-extract-plugin
export default {"firstRow":"alarmDetailModal_firstRow__J2iG5","secondRow":"alarmDetailModal_secondRow__RdPmJ","alarmDetailMap":"alarmDetailModal_alarmDetailMap__cIb8q"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"firstRow\":\"alarmDetailModal_firstRow__J2iG5\",\"secondRow\":\"alarmDetailModal_secondRow__RdPmJ\",\"alarmDetailMap\":\"alarmDetailModal_alarmDetailMap__cIb8q\"}";
        // 1793842503986
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  